import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["id", "passive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import c, { createContext as m, useContext as L, useMemo as f, useState as b } from "react";
import { useId as T } from '../../hooks/use-id.js';
import { forwardRefWithAs as E, render as g } from '../../utils/render.js';
import { useIsoMorphicEffect as x } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as P } from '../../hooks/use-sync-refs.js';
import { useEvent as y } from '../../hooks/use-event.js';
var d = m(null);

function u() {
  var o = L(d);

  if (o === null) {
    var t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, u), t;
  }

  return o;
}

function H() {
  var _b = b([]),
      _b2 = _slicedToArray(_b, 2),
      o = _b2[0],
      t = _b2[1];

  return [o.length > 0 ? o.join(" ") : void 0, f(function () {
    return function (e) {
      var s = y(function (r) {
        return t(function (l) {
          return [].concat(_toConsumableArray(l), [r]);
        }), function () {
          return t(function (l) {
            var n = l.slice(),
                p = n.indexOf(r);
            return p !== -1 && n.splice(p, 1), n;
          });
        };
      }),
          a = f(function () {
        return {
          register: s,
          slot: e.slot,
          name: e.name,
          props: e.props
        };
      }, [s, e.slot, e.name, e.props]);
      return c.createElement(d.Provider, {
        value: a
      }, e.children);
    };
  }, [t])];
}

var A = "label";

function h(o, t) {
  var i = T(),
      _o$id = o.id,
      e = _o$id === void 0 ? "headlessui-label-".concat(i) : _o$id,
      _o$passive = o.passive,
      s = _o$passive === void 0 ? !1 : _o$passive,
      a = _objectWithoutProperties(o, _excluded),
      r = u(),
      l = P(t);

  x(function () {
    return r.register(e);
  }, [e, r.register]);

  var n = _objectSpread(_objectSpread({
    ref: l
  }, r.props), {}, {
    id: e
  });

  return s && ("onClick" in n && (delete n.htmlFor, delete n.onClick), "onClick" in a && delete a.onClick), g({
    ourProps: n,
    theirProps: a,
    slot: r.slot || {},
    defaultTag: A,
    name: r.name || "Label"
  });
}

var v = E(h),
    M = Object.assign(v, {});
export { M as Label, H as useLabels };